/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Pagina senza titolo',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Crea una nuova pagina e inseriscila come link',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Crea pagina Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Apri in Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'La tua pagina è stata creata',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Pagina creata',
  'editorExtensionLinkCreate.confluencePage.title': 'Crea nuova pagina',
  'editorExtensionLinkCreate.genericError.description': 'Aggiorna la pagina e riprova.',
  'editorExtensionLinkCreate.genericError.title': 'Si è verificato un problema',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Crea un ticket in linea e inserisci il ticket come link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Crea ticket Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Apri in Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Il tuo ticket è stato creato',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Ticket creato',
  'editorExtensionLinkCreate.jiraIssue.title': 'Crea nuovo ticket',
  'editorExtensionLinkCreate.keyword.create': 'crea',
  'editorExtensionLinkCreate.keyword.issue': 'ticket',
  'editorExtensionLinkCreate.keyword.new': 'nuovo',
  'editorExtensionLinkCreate.keyword.page': 'pagina',
  'editorExtensionLinkCreate.keyword.publish': 'pubblica',
  'editorExtensionLinkCreate.keyword.raise': 'segnala',
  'editorExtensionLinkCreate.keyword.space': 'spazio',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
